import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SidebarComponent } from './sidebar.component';
import { AuthService } from '@com.maessa.payroll.frontend/auth';

@Component({
  selector: 'app-gestion-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    SidebarComponent,
  ],
  template: `
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        #sidenav
        mode="side"
        [opened]="true"
        class="sidenav"
      >
        <app-sidebar />
      </mat-sidenav>
      <mat-sidenav-content>
        <mat-toolbar class="toolbar">
          <button mat-icon-button (click)="sidenav.toggle()" aria-label="Alternar menú lateral">
            <mat-icon>menu</mat-icon>
          </button>
          <span class="toolbar-title">Portal de Gestión</span>
          <span class="spacer"></span>
          @if (authService.currentUser(); as user) {
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-btn">
              <mat-icon>account_circle</mat-icon>
              <span>{{ user.name }}</span>
              <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu">
              <div class="user-menu-header">
                <strong>{{ user.name }}</strong>
                <small>{{ user.email }}</small>
              </div>
              <button mat-menu-item (click)="authService.logout()">
                <mat-icon>logout</mat-icon> Cerrar sesión
              </button>
            </mat-menu>
          }
        </mat-toolbar>
        <main class="main-content">
          <router-outlet />
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [`
    .sidenav-container {
      height: 100vh;
    }

    .sidenav {
      width: 250px;
      background: #072142;
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }

    .toolbar {
      position: sticky;
      top: 0;
      z-index: 100;
      background: linear-gradient(90deg, #0d4482 0%, #1983c6 100%) !important;
      color: #ffffff !important;
      box-shadow: 0 2px 8px rgba(13, 68, 130, 0.25);
    }

    .toolbar button {
      color: #ffffff !important;
    }

    .toolbar-title {
      font-size: 1.05rem;
      font-weight: 600;
      margin-left: 8px;
      letter-spacing: 0.02em;
    }

    .spacer {
      flex: 1 1 auto;
    }

    .user-btn {
      color: #ffffff !important;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .dropdown-arrow {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    .user-menu-header {
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      font-size: 0.85rem;
    }

    .user-menu-header small {
      color: rgba(0, 0, 0, 0.54);
      margin-top: 2px;
    }

    .main-content {
      padding: 0;
      min-height: calc(100vh - 64px);
      background-color: #f4f7fb;
    }
  `],
})
export class GestionLayoutComponent {
  readonly authService = inject(AuthService);
}
